export default __webpack_public_path__ + "static/media/DENTISTCERTIFICATE_EN.4c1cbdb0.png";